export const CMS_PRODUCT_BOX_LIST_V2_SPACE_BETWEEN = 16;
